import { createFieldBase, FieldBase, FieldBaseArguments } from './FieldBase';

export function createDropdownField({
  value,
  items,
  ...options
}: DropdownFieldArguments): DropdownField {
  const fieldBase = createFieldBase(options);

  let self: DropdownField = {
    ...fieldBase,
    value,
    componentType: 'dropdown-kendo',
    items: items,
  };

  return self;
}

// TYPES:
export interface DropdownFieldArguments extends FieldBaseArguments {
  value: string | number;
  items: Item[];
}

export interface DropdownField extends FieldBase {
  componentType: string;
  items: Item[];
  value: string | number | boolean;
}

export interface Item {
  label?: string;
  value: number | string;
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/models/Field/DropdownField.ts